import axios from 'axios';
import {CommonUtil} from './CommonUtil';

export default class RequestUtil {

    static version = -1;
    static prvdr = null;

    /**
     * Common request provider
     *
     * @returns {AxiosInstance}
     */
    static provider() {
        if (!this.prvdr) {
            this.prvdr = axios.create({
                baseURL: '/8AHbSr',
            });
        }

        return this.prvdr;
    }

    /**
     * GET request
     *
     * @param method
     * @param data
     * @param options
     */
    static async get(method, data, options = {}) {
        if (false === CommonUtil().isEmptyObject(data)) {
            const urlParams = new URLSearchParams(data).toString();
            if (method.indexOf('?') > -1) {
                method += '&' + urlParams;
            } else {
                method += '?' + urlParams;
            }
        }

        return this.provider()
            .get(method, options)
            .then(res => this.parseResponse(res.data))
            .catch(this.parseErrors);
    }

    /**
     * POST request
     *
     * @param method
     * @param data
     */
    static async post(method, data) {
        return this.provider()
            .post(method, data)
            .then(res => this.parseResponse(res.data))
            .catch(this.parseErrors);
    }

    /**
     * PUT request
     *
     * @param method
     * @param data
     */
    static async put(method, data) {
        return this.provider()
            .put(method, data)
            .then(res => this.parseResponse(res.data))
            .catch(this.parseErrors);
    }

    /**
     * PATCH request
     *
     * @param method
     * @param data
     */
    static async patch(method, data) {
        return this.provider()
            .patch(method, data)
            .then(res => this.parseResponse(res.data))
            .catch(this.parseErrors);
    }

    /**
     * DELETE request
     *
     * @param method
     */
    static delete(method) {
        return this.provider()
            .delete(method)
            .then(res => this.parseResponse(res.data))
            .catch(this.parseErrors);
    }

    /**
     * Common success
     *
     * @param data
     * @returns {*}
     */
    static parseResponse(data) {
        if (data && data.success) {
            return data.data;
        } else if (data && data.errors) {
            data.errors.map(error => {
                console.error(
                    error.message || 'Something went wrong 🤔'
                );
            });
        }

        return {};
    }

    /**
     * Common errors
     *
     * @param response
     */
    static parseErrors({response}) {
        const data = response?.data || {}, status = response?.status || -1024;

        let errors;
        if (data && data.errors) {
            errors = data.errors.map(
                error => {
                    error.code = status;

                    return error;
                }
            )
        } else if (status === 401) {
            errors = [{
                message: 'Please log in to access this section.',
                code: status
            }]
        } else if (status === 500) {
            errors = [{
                message: 'Unfortunately, the server was unable to correctly process your request on the server. We are already understanding the problem.',
                code: status
            }]
        } else {
            errors = [{
                message: 'Unknown error',
                code: status
            }]
        }

        throw errors;
    }
}
